/* RK photo tint - product photos exported on pure white get a faint visible box inside the
   #f8f8f9 frames (PLP tile, PDP stage, search, wishlist). Sample one corner of each product
   image once it loads; if it is white, darken it 255->248 with a CSS filter (computed on the
   element itself, so it survives carousel transforms, unlike mix-blend-mode). Already-off-white
   photos are left alone. The Shopify CDN sends Access-Control-Allow-Origin: *, so the sample
   is allowed; if a browser blocks it, the photo simply shows as it is. Owner-facing outcome:
   photos can be uploaded on white OR off-white and both sit flush. */
(function () {
  var SEL = 'img.rk-card__img, img.rk-pdp__img, img.rk-search__result-img, img.rk-pdp__pack-img';
  var canvas, ctx;
  function isWhite(img) {
    try {
      if (!canvas) { canvas = document.createElement('canvas'); canvas.width = 4; canvas.height = 4; ctx = canvas.getContext('2d', { willReadFrequently: true }); }
      var w = img.naturalWidth, h = img.naturalHeight; if (!w || !h) return false;
      /* four 2px corner samples */
      var corners = [[0, 0], [w - 2, 0], [0, h - 2], [w - 2, h - 2]], white = 0;
      for (var i = 0; i < 4; i++) {
        ctx.drawImage(img, corners[i][0], corners[i][1], 2, 2, 0, 0, 2, 2);
        var d = ctx.getImageData(0, 0, 2, 2).data, sum = 0;
        for (var j = 0; j < d.length; j += 4) sum += (d[j] + d[j + 1] + d[j + 2]) / 3;
        if (sum / 4 >= 252) white++;
      }
      return white >= 3;
    } catch (e) { return false; /* tainted canvas or decode error: leave the photo alone */ }
  }
  function apply(img) { img.style.filter = 'brightness(0.9725)'; img.dataset.rkTint = 'white'; }
  function check(img) {
    if (img.dataset.rkTint) return; img.dataset.rkTint = '1';
    var src = img.currentSrc || img.src; if (!src) return;
    if (/^data:|^blob:/.test(src) || src.indexOf(location.origin) === 0) { if (isWhite(img)) apply(img); return; }
    /* cross-origin (Shopify CDN): re-request with CORS so the canvas is readable; same URL, so it is served from cache */
    var probe = new Image(); probe.crossOrigin = 'anonymous';
    probe.onload = function () { if (isWhite(probe)) apply(img); };
    probe.src = src;
  }
  function watch(img) {
    if (img.dataset.rkWatched) return; img.dataset.rkWatched = '1';
    /* Homepage rails sit on WHITE, not the off-white frame: their own CSS brightens every photo
       to pure white (rk-collection-rail.liquid), and this inline darkening overrode it, so the
       pure-white uploads came out grey in "Featured Pieces". Leave rail photos alone. */
    if (img.closest && img.closest('.rk-rail')) return;
    if (img.complete && img.naturalWidth) check(img); else img.addEventListener('load', function () { check(img); }, { once: true });
  }
  function scan(root) {
    var r = root || document;
    if (r.matches && r.matches(SEL)) watch(r);
    if (r.querySelectorAll) r.querySelectorAll(SEL).forEach(watch);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  new MutationObserver(function (m) { m.forEach(function (r) { r.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); }); }); }).observe(document.documentElement, { childList: true, subtree: true });
})();
